/**
 * The country the visitor's address is in, as the server looks it up
 * (GET /api/geo/country): what checkout goes by. Null when the lookup fails
 * or names no country, as in local development.
 */
export async function countryByAddress(): Promise<string | null> {
  try {
    const res = await fetch('/api/geo/country', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const { country } = (await res.json()) as { country?: unknown };
    return typeof country === 'string' ? country : null;
  } catch {
    return null;
  }
}

/**
 * Where the visitor most likely lives, as the dashboard guesses it
 * (web/src/shell/viewer.ts): their address, else the time zone given, and
 * what it went by. Null when neither names a country or the lookup fails.
 */
export async function countryGuess(
  timeZone: string | null,
): Promise<{ country: string; source: 'ip' | 'timezone' } | null> {
  try {
    const query = timeZone ? `?timeZone=${encodeURIComponent(timeZone)}` : '';
    const res = await fetch(`/api/geo/country${query}`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const { country, source } = (await res.json()) as {
      country?: unknown;
      source?: unknown;
    };
    if (typeof country !== 'string') return null;
    return { country, source: source === 'ip' ? 'ip' : 'timezone' };
  } catch {
    return null;
  }
}
